<template>
  <v-menu
    :close-on-content-click="false"
    open-on-hover
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-avatar>
          <v-gravatar :email="user.email ? user.email : ''" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            {{ user.displayName }}
          </v-list-item-title>
          <v-list-item-subtitle>
            Tirex Corp.
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-icon>
            mdi-menu-down
          </v-icon>
        </v-list-item-action>
      </v-list-item>
    </template>

    <v-card>
      <v-list>
        <!-- <v-list-item @click="toggleLocale({ $i18n, $FeathersVuex })">
          <v-list-item-content>
              {{ $t('common.language') }}
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              slot="activator"
              class="toolbar-items"
              icon
              text
              >
              {{ $i18n.locale }}
            </v-btn>
          </v-list-item-action>
        </v-list-item> -->

        <v-list-item @click="$router.push({ path: '/user_preferences' })">
          <v-list-item-content>
            Preferences
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              slot="activator"
              class="toolbar-items"
              icon
              text
            >
              <v-icon>
                mdi-tune
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-list-item @click="logout">
          <v-list-item-content>
            Logout
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              slot="activator"
              class="toolbar-items"
              icon
              text
            >
              <v-icon>
                mdi-logout
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions } from 'vuex';
import AuthMixin from '../../mixins/auth';

export default {
  mixins: [
    AuthMixin,
  ],

  methods: {
    ...mapActions('app', [
      'toggleLocale',
    ]),

    logout() {
      this.$router.push('/logout');
    },
  },
};
</script>
